export default {
  "b2b.rezervace-vytvoreni.obdobi.label": "Period",
  "b2b.rezervace-vytvoreni.datumOd.label": "Date",
  "b2b.rezervace-vytvoreni.doplnkove-sluzby.label": "Additional Services",
  "b2b.rezervace-vytvoreni.poznamka.label": "Note",
  "b2b.rezervace-vytvoreni.fixni-naroky.label":
    "Fixed requirements for selected period and resource",
  "b2b.rezervace-vytvoreni.fixni-naroky.text":
    "Entered: {zadane} | Allowed: {povolene}",
  "b2b.rezervace-vytvoreni.save-dialog.title": "Submit Request",
  "b2b.rezervace-vytvoreni.submit": "Send reservation",
  "b2b.rezervace-vytvoreni.rychla-widget.title": "Quick Reservation Request",
  "b2b.rezervace-vytvoreni.rychla-widget.submit": "Create Reservation"
};
